import type { AppConfig } from '@onhandtech/onhand-fe-shared/lib/contracts/config/config'
import type { App } from 'contracts/config/app'
import type { AppDomains } from 'contracts/config/domains'
import type { Endpoints } from 'contracts/config/endpoints'
import type { FeatureNames } from 'contracts/config/features'
import deepFreeze from 'deep-freeze-strict'

export type Config = AppConfig<App, FeatureNames, AppDomains, Endpoints>

// eslint-disable-next-line no-underscore-dangle
let _config: Config

export const setConfig = (config: Config): Config => {
  _config = deepFreeze(config)
  return _config
}

export const getConfig = (): Config => {
  if (!_config) {
    console.warn('Warning - No config set yet')
    _config = CONFIG
  }

  return _config
}
